import type { MessageKey } from 'types/LocaleMessageKey';

export interface Store {
  id: number;
  store: MessageKey;
  href: string;
}

export interface StoreChain {
  id: number;
  storeName: MessageKey;
  stores: Store[];
}

export const japaneseStores: StoreChain[] = [
  {
    id: 0,
    storeName: 'bic_camera',
    stores: [
      {
        id: 0,
        store: 'bic_camera_ikebukuro',
        href: 'https://www.biccamera.com/bc/i/shop/shoplist/shop007.jsp',
      },
      {
        id: 1,
        store: 'bic_camera_shinjuki',
        href: 'https://www.biccamera.com/bc/i/shop/shoplist/shop116.jsp',
      },
      {
        id: 2,
        store: 'bic_camera_yurakucho',
        href: 'https://www.biccamera.com/bc/i/shop/shoplist/shop014.jsp',
      },
      {
        id: 3,
        store: 'bic_camera_lazona',
        href: 'https://www.biccamera.com/bc/i/shop/shoplist/shop038.jsp',
      },
    ],
  },
  {
    id: 1,
    storeName: 'yodobashi_camera',
    stores: [
      {
        id: 0,
        store: 'yodobashi_akiba',
        href: 'https://www.yodobashi.com/ec/store/0018/',
      },
      {
        id: 1,
        store: 'yodobashi_umeda',
        href: 'https://www.yodobashi.com/ec/store/0081/',
      },
    ],
  },
  {
    id: 2,
    storeName: 'softbank_shops',
    stores: [
      {
        id: 0,
        store: 'softbank_ginza',
        href: 'https://www.softbank.jp/shop/search/detail/TD31/',
      },
      {
        id: 1,
        store: 'softbank_omotesando',
        href: 'https://www.softbank.jp/shop/search/detail/T1D3/',
      },
      {
        id: 2,
        store: 'softbank_shibuya',
        href: 'https://www.softbank.jp/shop/search/detail/T198/',
      },
      {
        id: 3,
        store: 'softbank_roppongi',
        href: 'https://www.softbank.jp/shop/search/detail/T248/',
      },
      {
        id: 4,
        store: 'softbank_osaka',
        href: 'https://www.softbank.jp/shop/search/detail/K1U6/',
      },
      {
        id: 5,
        store: 'softbank_nagoya',
        href: 'https://www.softbank.jp/shop/search/detail/C300/',
      },
      {
        id: 6,
        store: 'softbank_sendai',
        href: 'https://www.softbank.jp/shop/search/detail/H524/',
      },
    ],
  },
];
